module.exports = {"title":"Tickets Assignment","both":"Patron and Box Office","boxOfficeOnly":"Box Office only","noOne":"No one","saveClose":"Save and Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateFlexpass/FlexpassDatesModal/locales/en.json
// module id = 1726
// module chunks = 0